export default {"src":"/_next/static/media/Bagh.086142a0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};